<template>
  <div
    class="tooltip tooltip__info"
    :class="[`tooltip__info_${position}`]"
  >
    <SvgInfoSvg
      :color="colorTooltip"
      @mouseenter="enterHandler"
      @mouseleave="leaveHandler"
    />
    <slot />
    <div
      class="title"
      v-if="isHover"
      :style="{left: leftPosition, maxWidth: maxWitdthTooltip}"
    >
      {{ $t(tooltipText) }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    tooltipText: string;
    position: 'top' | 'bottom';
    leftPosition: string;
    maxWitdthTooltip: string;
  }>(),
  {
    tooltipText: '',
    position: 'bottom',
    leftPosition: '50%',
  },
);

const colorTooltip = computed(() =>
  isHover.value ? 'var(--var-blue-50)' : 'var(--var-gray-200)',
);
const isHover = ref(false);

const enterHandler = () => {
  isHover.value = true;
};

const leaveHandler = () => {
  isHover.value = false;
};
</script>

<style scoped lang="scss">
.tooltip {
  position: relative;
  &__info {
    display: flex;
    align-items: center;
    gap: $g-2;
    cursor: default;
    .title {
      background: var(--var-blue-50);
      padding: $p-2;
      border-radius: $br-2;
      position: absolute;
      bottom: 0px;
      @include launcher-p3;
      color: var(--var-white-000);
      cursor: default;
      transform: translate(-50%, 100%);
      max-width: 250px;
      width: max-content;
      z-index: 1000;
      animation: animation-tooltip 0.35s linear;
    }
    &_top {
      .title {
        top: 0px;
        bottom: unset;
        transform: translate(-50%, -100%);
      }
    }
  }
}

@keyframes animation-tooltip {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
